import { useEffect, useMemo, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { applyTenantAccessDefaults, buildFullTenantAccessMap } from "../access/pageAccess";

export default function useTenantPageAccess(user) {
  const tenantId = String(user?.primaryTenantId || user?.tenantId || "").trim();
  const [tenantPageAccess, setTenantPageAccess] = useState(buildFullTenantAccessMap());

  useEffect(() => {
    let ignore = false;

    async function load() {
      if (!tenantId) {
        if (!ignore) setTenantPageAccess(buildFullTenantAccessMap());
        return;
      }

      try {
        const snap = await getDoc(doc(db, "tenants", tenantId));
        if (!snap.exists()) {
          if (!ignore) setTenantPageAccess(buildFullTenantAccessMap());
          return;
        }

        const tenantData = snap.data() || {};
        if (!ignore) {
          setTenantPageAccess(applyTenantAccessDefaults(tenantData.tenantPageAccess || {}));
        }
      } catch {
        if (!ignore) setTenantPageAccess(buildFullTenantAccessMap());
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, [tenantId]);

  return useMemo(() => tenantPageAccess, [tenantPageAccess]);
}
